import React from 'react';
import ToggleSensitiveDataButton, { ToggleSensitiveDataButtonProps } from './buttons/ToggleSensitiveDataButton';
import useSensitiveDataService from './sensitiveDataService';
import { useListContext } from 'framework/list';

interface PreloadedSensitiveListLayoutProps {
  children: React.ReactElement;
  timerId?: string;
  toggleSensitiveDataComponent?: React.FC<ToggleSensitiveDataButtonProps>;
  shouldShowSensitiveDataButton?: boolean;
}

const PreloadedSensitiveListLayout = ({
  children,
  timerId,
  toggleSensitiveDataComponent: ToggleSensitiveDataComponent = ToggleSensitiveDataButton,
  shouldShowSensitiveDataButton,
}: PreloadedSensitiveListLayoutProps) => {
  const { data: { items } = { items: [] } } = useListContext();

  const { isTimerActive, isShown, toggleSensitiveData } = useSensitiveDataService({
    loadSensitiveDataMethod: () => Promise.resolve({}),
    timerId,
  });

  const showButton = items?.length || shouldShowSensitiveDataButton;

  return React.cloneElement(children, {
    isSensitiveDataIsShown: isShown,
    toggleSensitiveDataButton: showButton ? (
      <ToggleSensitiveDataComponent
        key="toggle-sensitive-data"
        isShown={isShown}
        onClick={() => toggleSensitiveData([])}
        isTimerActive={isTimerActive}
      />
    ) : null,
  });
};

export default PreloadedSensitiveListLayout;
